import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
  name: 'getAge'
})
export class GetAgePipe implements PipeTransform {

  constructor(private translate: TranslateService) { }

  transform(date1: number | Date | string, date2?: number | Date | string): string {
    if (!date1) {
      return '';
    }

    const dateOne = new Date(date1);
    const dateTwo = date2 ? new Date(date2) : new Date();
    return this.getAgeString(dateOne, dateTwo);
  }

  getAgeString(dateOne: Date, dateTwo: Date): string {
    const andStr = this.translate.instant('SI_AND').toLowerCase();

    const dateDiff = new Date(dateTwo.getTime() - dateOne.getTime());
    const yearsDiff = dateDiff.getUTCFullYear() - new Date(0).getUTCFullYear();
    const monthsDiff = dateDiff.getUTCMonth();
    const daysDiff = dateDiff.getUTCDate() - 1;

    if (yearsDiff >= 2) {
      return this.getYearsText(yearsDiff);
    }

    if (yearsDiff >= 1 && monthsDiff >= 1) {
      return `${this.getYearsText(yearsDiff)} ${andStr} ${this.getMonthsText(monthsDiff)}`;
    }

    if (yearsDiff >= 1) {
      return `${this.getYearsText(yearsDiff)}`;
    }

    if (monthsDiff >= 1) {
      return `${this.getMonthsText(monthsDiff)}`;
    }

    if (daysDiff >= 7) {
      return `${this.getWeeksText(Math.floor(daysDiff / 7))}`;
    }

    return this.getDaysText(daysDiff);
  }

  getYearsText(years: number): string {
    const yearsText = years === 1
      ? this.translate.instant('SI_YEAR').toLowerCase()
      : this.translate.instant('SI_YEARS').toLowerCase();
    return `${years} ${yearsText}`;
  }

  getMonthsText(months: number): string {
    const monthsText = months === 1
      ? this.translate.instant('SI_MONTH').toLowerCase()
      : this.translate.instant('SI_MONTHS').toLowerCase();
    return `${months} ${monthsText}`;
  }

  getWeeksText(weeks: number): string {
    const weeksText = weeks === 1
      ? this.translate.instant('SI_WEEK').toLowerCase()
      : this.translate.instant('SI_WEEKS').toLowerCase();
    return `${weeks} ${weeksText}`;
  }

  getDaysText(days: number): string {
    const daysText = days === 1
      ? this.translate.instant('SI_DAY').toLowerCase()
      : this.translate.instant('SI_DAYS').toLowerCase();
    return `${days} ${daysText}`;
  }
}
